document.addEventListener("DOMContentLoaded", function() {
  const game = document.getElementById('matcha-catch-area');
  const bowl = document.getElementById('matcha-bowl');
  const scoreDisplay = document.getElementById('matcha-score');
  const timerDisplay = document.getElementById('matcha-timer');
  const startBtn = document.getElementById('matcha-start-btn');

  if (!game || !bowl) return;

  let score = 0;
  let timeLeft = 30;
  let gameInterval, dropInterval;
  let isTouching = false;

  function moveBowl(x) {
    const rect = game.getBoundingClientRect();
    const relativeX = x - rect.left - bowl.offsetWidth / 2;
    bowl.style.left = Math.min(Math.max(0, relativeX), game.offsetWidth - bowl.offsetWidth) + 'px';
  }

  game.addEventListener('mousemove', e => moveBowl(e.clientX));

  game.addEventListener('touchstart', e => {
    isTouching = true;
    moveBowl(e.touches[0].clientX);
  });

  game.addEventListener('touchmove', e => {
    if (isTouching) moveBowl(e.touches[0].clientX);
  });

  game.addEventListener('touchend', () => isTouching = false);

  startBtn.addEventListener('click', startGame);

  function startGame() {
    score = 0;
    timeLeft = 30;
    scoreDisplay.textContent = `Score: ${score}`;
    timerDisplay.textContent = `Time: ${timeLeft}`;
    startBtn.disabled = true;

    gameInterval = setInterval(updateTimer, 1000);
    dropInterval = setInterval(createDrop, 800);
  }

  function updateTimer() {
    timeLeft--;
    timerDisplay.textContent = `Time: ${timeLeft}`;
    if (timeLeft <= 0) endGame();
  }

  function createDrop() {
    const drop = document.createElement('div');
    drop.style.position = 'absolute';
    drop.style.width = '20px';
    drop.style.height = '20px';
    drop.style.borderRadius = '50%';
    drop.style.background = 'radial-gradient(circle at 30% 30%, #a5d6a7, #81c784)';
    drop.style.left = Math.random() * (game.offsetWidth - 20) + 'px';
    drop.style.top = '0px';
    game.appendChild(drop);

    let dropTop = 0;
    const fallSpeed = 2 + Math.random() * 3;
    const fallInterval = setInterval(() => {
      dropTop += fallSpeed;
      drop.style.top = dropTop + 'px';

      const dropRect = drop.getBoundingClientRect();
      const bowlRect = bowl.getBoundingClientRect();

      if (
        dropRect.bottom >= bowlRect.top &&
        dropRect.left >= bowlRect.left &&
        dropRect.right <= bowlRect.right
      ) {
        score++;
        scoreDisplay.textContent = `Score: ${score}`;
        drop.remove();
        clearInterval(fallInterval);
      }

      if (dropTop > 400) {
        drop.remove();
        clearInterval(fallInterval);
      }
    }, 20);
  }

  function endGame() {
    clearInterval(gameInterval);
    clearInterval(dropInterval);
    game.querySelectorAll('div').forEach((d, i) => {
      if (i > 0) d.remove();
    });
    startBtn.disabled = false;
    alert(`Time’s up! You brewed ${score} bowls of matcha! 🍵`);
  }
});
